export const canonicalUrl = (path) => {
  if (!path) {
    return ''
  }
  return String(path).split('?')[0].split('#')[0]
}
